import { CKEditor } from '@ckeditor/ckeditor5-react';
import { MathJax, MathJaxContext } from 'better-react-mathjax';
import React, { useEffect, useRef, useState } from 'react';
import ClassicEditor from 'ckeditor5-classic-with-mathtype';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { UPLOAD_LOGO } from '../../../../../app/service/school.service';
import { GET_QUESTION_SOURCES_list } from '../../../../../app/service/content-module/question-source';
import { CREATE_CONTENT_QUESTION, DELETE_CONTENT_QUESTION, GET_CONTENT_QUESTIONS, UPDATE_CONTENT_QUESTION } from '../../../../../app/service/content-module/question-service';


interface Props {
    boardUuid: any;
    mediumUuid: any;
    standardUuid: any;
    subjectUuid: any;
    chapterUuid: any;
    topicUuid: any;
    validationStatus: string;
}
const UploadsValidationStatusQuestionsList: React.FC<Props> = (props: Props) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [questionsList, setQuestionsList] = useState<any>([]);
    const [selectedOption, setSelectedOption] = useState<string>('multiple_choice_questions');
    const [questionImg, setQuestionImg] = useState<any[]>([]);
    const [imageLoader, setImageLoader] = useState(false);
    const [questionUuid, setQuestionUuid] = useState<string>('');
    const [questionsData, setQuestionsData] = useState<any>([]);
    const [updateQuestionsData, setUpdateQuestionsData] = useState<any>([]);
    const [canShowCkeditor, setCanShowCkeditor] = useState(false);
    const [inputData, setInputData] = useState<any>();
    const [questionData, setQuestionData] = useState<any>();
    const [canShowCKeditorPopup, setCanShowCKeditorPopup] = useState(false);
    const [canShowCKeditorAddPopup, setCanShowCKeditorAddPopup] = useState(false);
    const [loadingCkeditor, setLoadingCkeditor] = useState(false);
    const [currentQuestionData, setCurrentQuestionData] = useState<any>([]);
    const [questionIndex, setQuestionIndex] = useState<any>(null);
    const [optionIndex, setOptionIndex] = useState<any>(null);
    const [correctAnswer, setCorrectAnswer] = useState<any>('');
    const [editor, setEditor] = useState<any>();
    const [questionNumber, setQuestionNumber] = useState<any>('');
    const [questionLevel, setQuestionLevel] = useState<string>("MEDIUM");
    const [questionExplanation, setQuestionExplanation] = useState<string>("");
    const [selectSource, setSelectSource] = useState<string>("");
    const [audioList, setAudioList] = useState<any>([]);
    const [videoList, setVideoList] = useState<any>([]);
    const [selectAudio, setSelectAudio] = useState<string>("");
    const [selectVideo, setSelectVideo] = useState<string>("");
    const [canShowExplanation, setCanShowExplanation] = useState(false);
    const [alphabets, setAlphabets] = useState<any>(["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"]);
    const history = useHistory();
    const listRef: any = useRef(null);
    const editorRef = useRef(null);
    const [sourceList, setSourceList] = useState<any>([]);
    const [sourceError, setSourceError] = useState<string>("");
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const [questionIndexNo, setQuestionIndexNo] = useState<number>(0);
    const [questionUsed, setQuestionUsed] = useState<string>("1");
    const [questionAsked, setQuestionAsked] = useState<string>("");
    const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);
    const boardUuid = props.boardUuid;
    const mediumUuid = props.mediumUuid;
    const standardUuid = props.standardUuid;
    const subjectUuid = props.subjectUuid;
    const chapterUuid = props?.chapterUuid;
    const topicUuid = props?.topicUuid;
    const validationStatus = props?.validationStatus
    const audioRef = useRef<HTMLAudioElement>(null);
    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        fethAllData();


    }, []);



    const fethAllData = async () => {
        setLoading(true);
        try {
            await getSorceList();
            await getQuestionsList();
            await getVideoList();
            await getAudioList();
            setLoading(false);

        } catch (error) {
            setLoading(false);

        }
    }

    const getQuestionsList = async () => {
        try {
            const payLoad = {
                board_uuid: boardUuid,
                medium_uuid: mediumUuid,
                standard_uuid: standardUuid,
                subject_uuid: subjectUuid,
                chapter_uuid: chapterUuid,
                topic_uuid: topicUuid,
                sorting_type: "ASC",
                content_type: "QUESTION"
            }
            const res: any = await GET_CONTENT_QUESTIONS(payLoad, 0, 1000000);
            if (res) {
                if (res.status === 'fail') {
                    toast.error(res.err);
                    setLoading(false);
                } else {
                    const data = res?.data;
                    setQuestionsList(data);
                    if (data && data?.length > 0) {
                        setUpdateQuestionsData(data);
                    } else {
                        setUpdateQuestionsData([]);
                    }
                }
            }
        } catch (error) {

        }

    }
    const getVideoList = async () => {
        try {
            const payLoad = {
                board_uuid: boardUuid,
                medium_uuid: mediumUuid,
                standard_uuid: standardUuid,
                subject_uuid: subjectUuid,
                chapter_uuid: chapterUuid,
                topic_uuid: topicUuid,
                sorting_type: "ASC",
                content_type: "VIDEO"
            }
            const res: any = await GET_CONTENT_QUESTIONS(payLoad, 0, 1000000);
            if (res) {
                if (res.status === 'fail') {
                    toast.error(res.err);
                    setLoading(false);
                } else {
                    const data = res?.data;
                    setVideoList(data);
                }
            }
        } catch (error) {

        }

    }
    const getAudioList = async () => {
        try {
            const payLoad = {
                board_uuid: boardUuid,
                medium_uuid: mediumUuid,
                standard_uuid: standardUuid,
                subject_uuid: subjectUuid,
                chapter_uuid: chapterUuid,
                topic_uuid: topicUuid,
                sorting_type: "ASC",
                content_type: "AUDIO"
            }
            const res: any = await GET_CONTENT_QUESTIONS(payLoad, 0, 1000000);
            if (res) {
                if (res.status === 'fail') {
                    toast.error(res.err);
                    setLoading(false);
                } else {
                    const data = res?.data;
                    setAudioList(data);
                }
            }
        } catch (error) {

        }

    }
    const getSorceList = async () => {
        try {
            const payLoad = {
                limit: 100000
            }
            const res: any = await GET_QUESTION_SOURCES_list(payLoad);
            if (res) {
                if (res.status === 'fail') {
                    toast.error(res?.err);
                } else {
                    const data = res?.data;
                    setSourceList(data);
                }
            }
        } catch (error) {

        }

    };

    const onUpdate = () => {
        currentQuestionData[0].mode_type = parseInt(questionUsed);
        currentQuestionData[0].difficulty_level = questionLevel;
        currentQuestionData[0].question_info = questionAsked;
        currentQuestionData[0].question_source_uuid = selectSource;
        currentQuestionData[0].audio_name = selectAudio ? getFileName(selectAudio, audioList) : "";
        currentQuestionData[0].audio_url = selectAudio;
        currentQuestionData[0].video_name = selectVideo ? getFileName(selectVideo, videoList) : "";
        delete currentQuestionData[0].created_dt;
        delete currentQuestionData[0].updated_dt;
        // currentQuestionData[0].explanation = questionExplanation ? questionExplanation : "";
        setIsFormSubmitted(true);
        if (questionLevel) {
            UPDATE_CONTENT_QUESTION(currentQuestionData[0]?.uuid, currentQuestionData[0]).then((res: any) => {
                if (res.status === 'fail') {
                    toast.error(res?.err);
                } else {
                    toast.success(res.message);
                    setCurrentQuestionData([]);
                    setCanShowCKeditorPopup(false);
                    getQuestionsList();
                    stopMedia();
                    handleClearData();
                }
            });
        }
    }

    const getFileName = (value: any, listItems: any) => {
        const foundItem = listItems.find((item: any) => item.question_info === value);
        return foundItem?.question || "";
    }
    function onViewQuestion(name: any) {
        return { __html: name };
    }

    function onChange(e: any, editor: any) {
        setInputData(editor.getData());
    };

    function onClickEdit(questions: any, i: number, backNext?: string) {
        setCurrentIndex(i);
        setQuestionIndexNo(i + 1);
        setQuestionExplanation(questions?.explanation);
        setCurrentQuestionData([]);
        setQuestionImg([]);
        setQuestionUsed(questions?.mode_type);
        setQuestionLevel(questions?.difficulty_level);
        setQuestionAsked(questions?.question_info);
        setSelectSource(questions?.question_source_uuid);
        setQuestionUuid(questions?.uuid);
        setSelectAudio(questions?.audio_url);
        setSelectVideo(questions?.video_url);
        // setQuestionImg(questions?.question?.images);
        setSelectedOption(questions?.question_type)
        setCanShowCKeditorPopup(true);
        setQuestionData(questions.question);
        const data = currentQuestionData;
        if (backNext) {
            setCurrentQuestionData([questions]);
        } else {
            data.push(questions);
            setCurrentQuestionData(data);
        }
        questionImg.push(questions)
        setLoadingCkeditor(true);
        setCanShowCkeditor(false);
        setTimeout(() => {
            setLoadingCkeditor(false);
        }, 1000);
        stopMedia();
    }

    function onEditOptions(question: any, i: number, option: any, j: number) {
        setInputData("");
        setCanShowExplanation(false);
        setQuestionIndex(i);
        setOptionIndex(j);
        setQuestionData(option.value);
        setCanShowCkeditor(true);
    }

    function getCorrectAnswer(option: any) {
        for (let i = 0; i < alphabets.length; i++) {
            if (option === alphabets[i]) {
                return alphabets[i - 1];
            }
        }
    }

    function onDeleteOptions(question: any, i: number, option: any, optionIndex: number) {
        setLoadingCkeditor(true);
        const data = currentQuestionData;
        for (let i = 0; i < data.length; i++) {
            for (let j = 0; j < data[i].options.length; j++) {
                if (option.options === data[i].correct_answer) {
                    data[i].correct_answer = "";
                } else {
                    if (data[i].correct_answer === data[i].options[j].option) {

                        if (j > optionIndex) {
                            data[i].correct_answer = getCorrectAnswer(data[i].options[j].option);
                        } else {
                            data[i].correct_answer = data[i].correct_answer;
                        }
                    }
                }
            }
        }
        data[0].options.splice(optionIndex, 1);

        for (let i = 0; i < data[0].options.length; i++) {
            for (let j = 0; j < alphabets.length; j++) {
                if (i === j) {
                    data[0].options[i].option = alphabets[j];
                    data[0].options[i].value = data[0].options[i].value;
                }
            }
        }

        setTimeout(() => {
            setCurrentQuestionData(data);
            setLoadingCkeditor(false);
            setCanShowCkeditor(false);
        }, 1000);

    }
    function onDeleteExplanation(question: any, i: number) {
        setLoadingCkeditor(true);
        const data = currentQuestionData;
        for (let i = 0; i < data.length; i++) {
            data[i].explanation = "";
        }

        setTimeout(() => {
            setCurrentQuestionData(data);
            setLoadingCkeditor(false);
            setCanShowCkeditor(false);
        }, 1000);

    }
    function onEditExplanation(question: any, i: number) {
        setInputData("");
        setCanShowExplanation(true);
        setQuestionData(question?.explanation);
        setOptionIndex(null);
        setCanShowCkeditor(true);
    }
    function onEditQuestion(question: any, i: number) {
        setInputData("");
        setCanShowExplanation(false);
        setQuestionData(question?.question);
        setQuestionIndex(i);
        setOptionIndex(null);
        setCanShowCkeditor(true);
    }

    const handleClose = () => {
        setCanShowCKeditorPopup(false);
        getQuestionsList();
        // getWorksheetQuestions(worksheetNumber);
        setCurrentQuestionData([]);
        setQuestionIndex(null);
        setOptionIndex(null);
        handleClearData();
        stopMedia();
    }

    function getOptionLists(item: any, optionData: any) {
        const answerOptions = item;
        answerOptions.push({
            option: '',
            value: ''
        });
        for (let i = 0; i < answerOptions.length; i++) {
            for (let j = 0; j < alphabets.length; j++) {
                if (i === j && (answerOptions[i].value === '' || answerOptions[i].option === '')) {
                    answerOptions[i].option = alphabets[j];
                    answerOptions[i].value = optionData;
                }
            }
        }

        return answerOptions;
    }

    function onSave() {
        setLoadingCkeditor(true);
        const data = currentQuestionData;
        if (canShowExplanation) {
            setQuestionExplanation(inputData);
            // data[questionIndex].explanation = inputData ? inputData : data[questionIndex].explanation;
            currentQuestionData[0].explanation = inputData ? inputData : currentQuestionData[0].explanation;
            setCanShowExplanation(false);
            setTimeout(() => {
                setCurrentQuestionData(data);
                setLoadingCkeditor(false);
                setCanShowCkeditor(false);
            }, 1000);
        }
        else if (questionIndex !== null && optionIndex !== null) {
            data[questionIndex].options[optionIndex].value = inputData ? inputData : data[questionIndex].options[optionIndex].value;
            // data[questionIndex].options[optionIndex].value = inputData;
            setTimeout(() => {
                setCurrentQuestionData(data);
                setLoadingCkeditor(false);
                setCanShowCkeditor(false);
            }, 1000);
        } else if (questionIndex !== null) {
            data[questionIndex].question = inputData ? inputData : data[questionIndex].question;
            // data[0].question = inputData;
            setTimeout(() => {
                setCurrentQuestionData(data);
                setLoadingCkeditor(false);
                setCanShowCkeditor(false);
            }, 1000);
        } else {
            data[0].options = getOptionLists(data[0].options, inputData);
            setTimeout(() => {
                setCurrentQuestionData(data);
                setLoadingCkeditor(false);
                setCanShowCkeditor(false);
            }, 1000);
        }
        setQuestionData(inputData);
    }

    function handleQuestionOptions(item: any, index: number) {
        const data = currentQuestionData;
        for (let i = 0; i < alphabets.length; i++) {
            if (index === i) {
                data[0].correct_answer = alphabets[i];
            }
        }
        setCurrentQuestionData(data);
    }



    function onAddAnswerOptions() {
        setCanShowExplanation(false);
        setCanShowCkeditor(true);
        setQuestionData('');
        setOptionIndex(null);
        setQuestionIndex(null);
    }



    function getOptions(index: number) {
        for (let i = 0; i < alphabets.length; i++) {
            if (index === i) {
                return alphabets[i];
            }
        }
    }

    function createMarkup(name: any) {

        return { __html: name };
    }


    function getStatusSaveBtn(optionType?: string) {
        if (questionsData.length > 1) {
            return false;
        } else {
            return true;
        }
    }




    function getCkeditorValue(type: any) {
        if (type === 'question') {
            if (questionsData.length > 0) {
                return questionsData[0];
            }
        } else {
            const preparedOptions = [];
            const data = questionsData.slice(1);
            for (let i = 0; i < data.length; i++) {
                preparedOptions.push({
                    option: getOptions(i),
                    value: data[i]
                })
            }
            return preparedOptions;
        }
    }



    const onDelete = (data: any) => {
        setLoading(true);
        DELETE_CONTENT_QUESTION(data?.uuid).then((res: any) => {
            if (res.status === 'fail') {
                const errorMessage = Array.isArray(res?.err) ? res?.err[0] : res?.err
                toast.error(errorMessage);
                setLoading(false);
            } else {
                setLoading(false);
                toast.success(res.message);
                getQuestionsList();
            }
        });
    }


    const uploadAdapter = (loader: any) => {
        return {
            upload: () => {
                return new Promise((resolve, reject) => {
                    const body = new FormData();
                    loader.file.then((file: any) => {
                        body.append("file", file);
                        UPLOAD_LOGO(body).then((res: any) => {
                            if (res.status === 'fail') {
                                toast.error(res?.error);
                            } else {
                                let imgUrl = res.url
                                resolve({ default: `${res?.base_url}${imgUrl}` })
                            }
                        });

                    })
                })
            }
        }
    }


    const handleNext = () => {
        handleClearData();
        if (currentIndex < updateQuestionsData.length - 1) {
            const newIndex = currentIndex + 1;
            setCurrentIndex(newIndex);
            onClickEdit(updateQuestionsData[newIndex], newIndex, "backNext");
        }
    };
    const handleClearData = () => {
        setSelectAudio("");
        setSelectVideo("");
    }

    const handleBack = () => {
        handleClearData();
        if (currentIndex > 0) {
            const newIndex = currentIndex - 1;
            setCurrentIndex(newIndex);
            onClickEdit(updateQuestionsData[newIndex], newIndex, "backNext");
        }
    };
    const capitalizeWords = (name: string): string => {
        return name
            .split(' ') // Split the string by spaces into an array of words
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter and lowercase the rest
            .join(' '); // Join the array back into a single string
    };
    const stopMedia = () => {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }

    };
    return (
        <div>

            <div className={`modal fade parent-modal-fade ${canShowCKeditorPopup ? 'show' : 'false'}`} style={{ display: (canShowCKeditorPopup ? "block" : 'none') }} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog worksheet-quesions-dialog" role="document">
                    <div className="modal-content worksheet-questions-model">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Update Question</h5>
                            <button type="button" className="close popup-close cursor-pointer" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ overflowX: 'hidden' }}>
                            <div className='row mt-1 mb-3'>
                                <div className='col-md-3'>
                                    <div className="form-group ">
                                        <label className='control-label  fw-bold mb-1'>Question will be used for</label>
                                        <select name="level" id="level" className="form-select f14" value={questionUsed} onChange={(e) => setQuestionUsed(e.target.value)}>
                                            <option value="1">ABHYAAS</option>
                                            <option value="2">PARIKSHA</option>
                                            <option value="3">BOTH ABHYAAS AND PARIKSHA</option>
                                        </select>
                                    </div>
                                </div>
                                <div className='col-md-2'>
                                    <div className="form-group ">
                                        <label className='control-label  fw-bold mb-1'>Difficulty Level</label>
                                        <select name="level" id="level" className="form-select f14" value={questionLevel} onChange={(e) => setQuestionLevel(e.target.value)}>
                                            <option value="EASY">Easy</option>
                                            <option value="MEDIUM">Medium</option>
                                            <option value="HARD">Hard</option>
                                        </select>
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <div className="form-group ">
                                        <label className='control-label fw-bold mb-1'>Question asked in <span className='text-inprogess f12'>(for ex.JEE 2013, NDA 2011)</span></label>
                                        <input className="form-control" type="text" name="question_asked" value={questionAsked} onChange={(e) => setQuestionAsked(e.target.value)} />
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <div className="form-group ">
                                        <label className='control-label  fw-bold mb-1'>Question Source</label>
                                        <select name="source" id="source" className="form-select ft-14 " value={selectSource} onChange={(e) => setSelectSource(e.target.value)}>
                                            <option value="">Select source</option>
                                            {sourceList?.map((name: any, i: number) => (
                                                <option key={i} value={name?.uuid}>
                                                    {name?.source}
                                                </option>
                                            ))}
                                        </select>
                                        {(sourceError && !selectSource) && <p className='text-danger'>Please select source</p>}
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <div className="form-group ">
                                        <label className='control-label  fw-bold mb-1'>Video</label>
                                        <select name="video" id="video" className="form-select ft-14 " value={selectVideo} onChange={(e) => setSelectVideo(e.target.value)}>
                                            <option value="">Select video</option>
                                            {videoList?.map((name: any, i: number) => (
                                                <option key={i} value={name?.question_info}>
                                                    {name?.question}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <div className="form-group ">
                                        <label className='control-label  fw-bold mb-1'>Audio</label>
                                        <select name="audio" id="audio" className="form-select ft-14 " value={selectAudio} onChange={(e) => setSelectAudio(e.target.value)}>
                                            <option value="">Select audio</option>
                                            {audioList?.map((name: any, i: number) => (
                                                <option key={i} value={name?.question_info}>
                                                    {name?.question}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            {loadingCkeditor &&
                                <div className="text-center p-5">
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            }
                            {!loadingCkeditor && <div>
                                <div className='cdk-question-view'>
                                    {currentQuestionData?.map((question: any, i: number) => (
                                        <div className="mt-1" key={i}>
                                            <div className='row'>
                                                <div className='row'>
                                                    <div className='col-md-1 pt-4'>
                                                        <span className='fw-bold ' style={{ fontSize: '22px' }}>Q{questionIndexNo}:</span>
                                                    </div>
                                                    <div className='col-md-7 mb-3 ' ref={listRef} style={{ paddingTop: '25px' }}>
                                                        <div className='d-flex'>
                                                            {selectVideo && <video ref={videoRef} src={selectVideo} className='w-25 rounded-3' controls></video>}
                                                            {selectAudio && <audio ref={audioRef} src={selectAudio} className="ms-3" controls></audio>}
                                                        </div>
                                                        <span className='fw-bold' style={{ fontSize: '22px' }}>
                                                            <MathJaxContext>
                                                                <MathJax>
                                                                    <div className="img_ck" dangerouslySetInnerHTML={onViewQuestion(question?.question)}></div>
                                                                </MathJax>
                                                            </MathJaxContext>
                                                        </span>
                                                    </div>
                                                    <div className='col-md-2 px-0 pb-0 pt-4'>
                                                        <i className="bi bi-pencil-square cursor-pointer edit-icon p-2 " onClick={() => onEditQuestion(question, i)}></i>
                                                    </div>
                                                </div>
                                                <div className='row pt-5'>
                                                    <div className='col-md-9'>
                                                        {question?.options?.map((options: any, j: number) => (
                                                            <div className='row' key={j}>
                                                                <div className='col-md-1'>
                                                                    <span>{options.option}.</span>
                                                                </div>
                                                                <div className='col-md-9'>
                                                                    <div className='row' style={{ position: 'relative' }}>
                                                                        <div className='col-md-8'>
                                                                            <MathJaxContext>
                                                                                <MathJax>
                                                                                    <span className='text-break img_ck' dangerouslySetInnerHTML={onViewQuestion(options.value)} ></span>
                                                                                </MathJax>
                                                                            </MathJaxContext>
                                                                        </div>
                                                                        <div className='col-md-4'>
                                                                            {j === 0 && <div style={{ position: 'absolute', top: '-30px', left: '390px' }}>Choose Correct Answer</div>}
                                                                            <input type='radio' name="option" defaultChecked={question.correct_answer === options.option} onChange={(e) => { handleQuestionOptions(options, j) }} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-2'>
                                                                    <i className="bi bi-pencil-square cursor-pointer edit-icon p-2" onClick={() => onEditOptions(question, i, options, j)}></i>
                                                                    <i className="bi bi-trash cursor-pointer edit-icon p-2" onClick={() => onDeleteOptions(question, i, options, j)}></i>
                                                                </div>
                                                            </div>
                                                        ))}
                                                        <div className='col-md-9 mt-3 mb-2'>
                                                            <h5>Explanation  <i className="bi bi-pencil-square cursor-pointer edit-icon p-2 f14 ms-2" onClick={() => onEditExplanation(question, i)}></i>
                                                                {question.explanation && <i className="bi bi-trash cursor-pointer edit-icon p-2 f14" onClick={() => onDeleteExplanation(question, i)}></i>}
                                                            </h5>
                                                            <div className='f16 text-break' dangerouslySetInnerHTML={createMarkup(question.explanation)} >
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-3 mb-2'>
                                                        <button className='btn btn-primary' onClick={() => onAddAnswerOptions()}>Add Answer Options</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {canShowCkeditor && <div className='mt-3'>
                                    <MathJaxContext>
                                        <CKEditor
                                            editor={ClassicEditor}
                                            id="editorId"
                                            data={questionData}
                                            config={{
                                                toolbar: {
                                                    items: [
                                                        'heading', 'MathType', 'ChemType',
                                                        '|',
                                                        'bold',
                                                        'italic',
                                                        'link',
                                                        'bulletedList',
                                                        'numberedList',
                                                        'imageUpload',
                                                        'insertTable',
                                                        'blockQuote',
                                                        'undo',
                                                        'redo',
                                                        '|',
                                                        'imageStyle:full', 'imageStyle:side',
                                                        'imageTextAlternative',
                                                        'imageResize',
                                                        'imageUploadMultiple',

                                                    ]
                                                },
                                                language: 'en',
                                            }}

                                            onChange={(event: any, editor: any) => {
                                                return onChange(event, editor);
                                            }}
                                            onReady={(editor: any) => {
                                                editorRef.current = editor;
                                                editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
                                                    return uploadAdapter(loader);
                                                };
                                                setEditor(editor);
                                            }}
                                        />
                                        <MathJax>
                                        </MathJax>
                                    </MathJaxContext>
                                    <div className='mt-2'>
                                        <button className='btn btn-primary' disabled={editor && editor.getData() ? false : true} onClick={() => onSave()}>Ok</button>&nbsp;
                                    </div>

                                </div>}
                            </div>}
                        </div>
                        <div className="modal-footer  d-flex justify-content-between">
                            <div className=''>
                                {updateQuestionsData?.length > 1 && <div>
                                    <button className={`q_nxt_btn ms-5 me-4  f16 ${currentIndex === 0 && "btn_disabled"}`} onClick={handleBack} disabled={currentIndex === 0}>
                                        Back
                                    </button>
                                    <button className={`q_nxt_btn  f16 ${currentIndex === updateQuestionsData?.length - 1 && "btn_disabled"}`} onClick={handleNext} disabled={currentIndex === updateQuestionsData.length - 1}>
                                        Next
                                    </button>
                                </div>}
                            </div>
                            <div className='questions-save-btn'>
                                <button className='btn btn-primary me-3' onClick={() => onUpdate()}>Update</button>
                                <button type="button" className="btn btn-secondary cursor-pointer" data-dismiss="modal" onClick={handleClose}>Close</button>&nbsp;
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {loading &&
                <div className="text-center p-5">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            }
            {!loading &&
                <div className=''>
                    <div className='mt-3 custom-scroll table-responsive'>
                        <table className='table questions-valid-table  mb-0'>
                            <thead>
                                <tr className='questions-valid-header'>
                                    <th className='text-center'>Questions</th>
                                    <th className='text-center' style={{ width: "120px" }}>Status</th>
                                    <th className='text-center' style={{ width: "170px" }}>Remark</th>
                                    <th className='text-center' style={{ width: "100px" }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {questionsList?.map((question: any, i: number) => (
                                    <tr>
                                        <td>
                                            <MathJaxContext>
                                                <MathJax>
                                                    <div className='d-flex'>
                                                        <p className='fw-bold mb-0' style={{ fontSize: '22px' }}>
                                                            Q{i + 1}:
                                                        </p>
                                                        <div className='ms-4 ps-2'>
                                                            <div className='d-flex'>
                                                                {question?.video_url && <video ref={videoRef} src={question?.video_url} className='w-25 rounded-3' controls></video>}
                                                                {question?.audio_url && <audio ref={audioRef} src={question?.audio_url} className="ms-3" controls></audio>}
                                                            </div>
                                                            <span className='fw-bold' style={{ fontSize: '22px' }}>
                                                                <div dangerouslySetInnerHTML={onViewQuestion(question.question)}></div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className='ms-5 ps-5'>
                                                        {question.options.map((options: any, j: number) => (
                                                            <div className='d-flex' key={j}>
                                                                <div className=''>
                                                                    <span>{options.option}.</span>
                                                                </div>
                                                                <div className='ms-3'>
                                                                    <span dangerouslySetInnerHTML={onViewQuestion(options.value)}></span>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </MathJax>
                                            </MathJaxContext>
                                        </td>
                                        <td className='text-center'>{question?.validation_status && capitalizeWords(question?.validation_status)}</td>
                                        <td className='text-center'>{question?.remarks}</td>
                                        <td className='text-center'>
                                            <i className="bi bi-pencil-square cursor-pointer edit-icon p-2" onClick={() => onClickEdit(question, i)}></i>
                                            <i className="bi bi-trash cursor-pointer p-2" onClick={() => onDelete(question)}></i>
                                        </td>
                                    </tr>))}
                            </tbody>
                        </table>
                    </div>
                    {questionsList?.length == 0 && <p className='text-center'>No Questions Found</p>}
                </div>

            }

        </div >
    );
};
export default UploadsValidationStatusQuestionsList;
